export default "__VITE_ASSET__bmjR3p17__"